// Docs/ContractOffer.tsx
import React from "react";
import {FC, FR} from "WideLayout/Layouts";
// @ts-ignore
import dogovorOfertWebp from '../../Static/img/docs/dogovor-ofert.webp'

const ContractOffer: React.FC = () => {
    return (
        <FC
            maxWidth="md"
            margin="auto"
            py="4rem"
            px={2}
        >
            <FC flexDirection="column" mb="2rem">
                <FR flexDirection="column" mb="2rem">
                    <img

                        src={dogovorOfertWebp}
                        alt="Договор Оферты"
                        style={{
                            maxWidth: '300px',
                            marginLeft: 'auto',
                            width: '100%',
                            height: 'auto'
                        }}
                    />
                </FR>

                <FC
                    fontSize="2.4rem"
                    lh={'3rem'}
                    fontWeight="bold"
                    mb="1.5rem"
                    cls={'text-nowrap'}
                    color="#212529">
                    Договор Оферты
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    1. ОБЩИЕ ПОЛОЖЕНИЯ
                </FC>

                <span>
                    1.1. В соответствии с положениями пункта 2 статьи 437 Гражданского Кодекса Российской Федерации,
                    настоящий Договор является публичной офертой (далее – «Оферта») ООО «Лайф Хелп» в лице генерального
                    директора Галимзянова Даниса Агзамовича, действующего на основании Устава, далее именуемый –
                    «Исполнитель», любому правоспособному и дееспособному физическому лицу, достигшему 16-летнего
                    возраста, выразившему готовность воспользоваться услугами, размещенными на сайтах:{' '}
                    <span onClick={() => window.location.href = 'https://life-help.ru/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.ru/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.pro/'}
                          style={{color: '#36f'}} className="text-nowrap">
                        https://life-help.pro/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.uk/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.uk/
                    </span>
                    , и принявшему условия настоящего Договора публичной оферты, далее именуемый «Пользователем», а
                    вместе именуемые Сторонами. После принятия условий настоящей оферты и началом пользования Сервисом
                    онлайн консультаций, лицо, производящее акцепт настоящей оферты, становится Пользователем.
                </span>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    1.2. ООО «Лайф Хелп» является Исполнителем по настоящему Договору и действуют от своего имени, но за
                    счет Психолога.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    1.3. Полным и безоговорочным акцептом настоящей публичной оферты считается факт начала пользования
                    Сервисом онлайн консультаций и регистрация на нем.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    1.4. С момента совершения акцепта Пользователь считаетсья ознакомившимся и согласившимся с настоящей
                    публичной офертой и, в соответствии с нормами действующего Законодательства РФ, Гражданским Кодексом
                    РФ, считается вступившим с Исполнителем в договорные отношения в соответствии с условиями настоящего
                    Договора.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    В настоящем договоре применяются следующие термины и определения:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Исполнитель –
                        </FC>{' '}
                        правообладатель сервиса онлайн-консультаций «Лайф Хелп», действующий от своего имени
                        по поручению Психолога.
                    </FC>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Психолог –
                        </FC>{' '}
                        физическое лицо, обладающее полной право – и дееспособностью, достигшее 18-летнего
                        возраста, имеющее высшее образование или прошедшее переподготовку в области
                        психологии, оказывающее помощь и консультирование Пользователей посредством Сервиса
                        онлайн консультаций, без выписывания медицинских рецептов.
                    </FC>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Пользователь
                        </FC>{' '}
                        – физическое лицо, обладающее полной право – и дееспособностью, достигшее 18-летнего
                        возраста, обратившееся к Психологу посредством Сервиса онлайн-консультаций путем
                        осуществления процедуры регистрации и создания личного кабинета, являющийся
                        Заказчиком по настоящему Договору.
                    </FC>
                    <span
                        className="mb-1"
                    >
                        <span
                            className={'fw-bold'}
                        >
                            Сервис онлайн-консультаций –
                        </span>{' '}
                        разработанная и администрируемая Агентом онлайн-платформа – сервис онлайн
                        консультаций «Лайф Хелп», размещенная в сети интернет по адресам:{' '}
                        <span onClick={() => window.location.href = 'https://life-help.ru/'}
                              style={{color: '#36f'}}
                              className="text-nowrap">
                        https://life-help.ru/
                    </span>,{' '}
                        <span onClick={() => window.location.href = 'https://life-help.pro/'}
                              style={{color: '#36f'}} className="text-nowrap">
                        https://life-help.pro/
                    </span>,{' '}
                        <span onClick={() => window.location.href = 'https://life-help.uk/'}
                              style={{color: '#36f'}}
                              className="text-nowrap">
                        https://life-help.uk/
                    </span>
                        , позволяющая осуществлять взаимодействие между Пользователем и Психологом. Все
                        исключительные права на Сервис онлайн-консультаций, доменные имена, а также любые
                        результаты интеллектуальной деятельности, включая, но не ограничиваясь, любые
                        тексты, фотографии, изображения, задания, формы, программы для ЭВМ и базы данных,
                        размещенные на Сервисе онлайн консультаций, принадлежат Исполнителю.
                    </span>
                    <span
                        className={'mb-1'}
                    >
                        <span
                            className={'fw-bold'}
                        >
                            Видеоконсультация –
                        </span>{' '}
                        онлайн-встреча на Сервисе онлайн-консультаций, участниками которой являются Психолог
                        и Пользователь на основе своей учетной записи, вход в которую осуществляется через
                        свой личный кабинет, продолжительность встречи устанавливается Психологом, но не
                        может быть менее 50 (пятидесяти) минут.
                    </span>
                    <span
                        className="mb-1"
                    >
                        <span
                            className="fw-bold"
                        >
                            Пользователь
                        </span>{' '}
                        – лицо, обладающее полной право – и дееспособностью, достигшее 18-летнего возраста,
                        обратившееся к Психологу посредством Сервиса онлайн консультаций путем осуществления
                        процедуры регистрации и создания личного кабинета.
                    </span>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Личный кабинет –
                        </FC>{' '}
                        персональная страница Пользователя на Сервисе онлайн-консультаций, доступ к которой
                        предоставляется после прохождения процедуры регистрации, где входом в Личный кабинет
                        является телефонный номер Пользователя (далее - «логин»), а паролем – автоматически
                        сгенерированный Сервисом онлайн-консультаций одноразовый код, который направляется
                        на телефонный номер Пользователя, после чего Пользователь самостоятельно задаёт
                        пароль для входа на Сервис онлайн-консультаций. При регистрации на Сервисе
                        онлайн-консультаций Пользователь заполняет обязательную анкету.
                    </FC>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Промокод
                        </FC>{' '}
                        - буквенно-цифровое обозначение, позволяющее Пользователю (держателю Промокода)
                        получать скидку на услугу при предъявлении такого Промокода на Сервисе
                        онлайн-консультаций. Порядок использования Промокодов, способы их активации указаны
                        в настоящем Договоре или на Сервисе онлайн-консультаций и могут быть изменены
                        Исполнителем в одностороннем порядке.
                    </FC>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Вебинар
                        </FC>{' '}
                        – вид оказания услуг, при которых происходит выступление Психолога (ведущего
                        вебинара) и приглашенных гостей (при наличии) на интересующие аудиторию темы и по
                        интересующим вопросам. Вебинар предлагается для просмотра неопределенному кругу
                        Пользователей, приобретших данную услугу.
                        <FC
                            ml="1.5rem"
                            marginTop="0.5rem"
                        >
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Даты проведения вебинара и ведущий определяются Исполнителем и могут быть изменены
                                Исполнителем в одностороннем порядке;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Тематика вебинаров определяется Исполнителем и не может быть изменена Пользователем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Продолжительность вебинара определяется Исполнителем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Платформа проведения вебинара определяется Исполнителем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Доступ к вебинару допускается как в режиме реального времени, так и в записи.
                            </FR>
                        </FC>
                    </FC>
                    <FC
                        className="mb-1"
                    >
                        <FC
                            fontWeight="bold"
                        >
                            Психотерапевтическая группа
                        </FC>{' '}
                        - вид услуг, групповые занятия для Пользователей, объединенных какой-либо общей
                        тематикой и/или психологической проблемой или комплексом взаимосвязанных
                        психологических проблем, со следующими основными характеристиками:
                        <FC
                            ml="1.5rem"
                            marginTop="0.5rem"
                        >
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Объединение Пользователей в группу производится Исполнителем с согласия Пользователя;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Даты проведения групповых занятий и их формат определяются Исполнителем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Тематика групп определяется Исполнителем и не может быть изменена Пользователем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Количество занятий определяется Исполнителем и Психологом в зависимости от тематики и
                                других факторов и доводится до сведения Пользователем;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Пропуск занятия не влечёт возврата оплаты за пропущенное занятие;
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Продолжительность одной сессии определяется Исполнителем и Психологом в зависимости от
                                тематики группового занятия и других факторов и доводится до сведения Пользователя.
                            </FR>
                            <FR fontSize="0.9rem"
                                mb="0.25rem"
                                color="#212529"
                            >
                                - Платформа проведения групповых занятий определяется Исполнителем.
                            </FR>
                        </FC>
                    </FC>
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    3. ПРЕДМЕТ ДОГОВОРА
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.1. Предметом настоящего Договора является предоставление Исполнителем Пользователю доступа к
                    функциональным возможностям Сервиса онлайн-консультаций, позволяющим осуществить выбор Психолога, а
                    также проведения Видеоконсультаций с Психологом по вопросу индивидуальной психологической работы с
                    Пользователем или работы в группе. При этом услуги проведения Видеоконсультаций Пользователю
                    оказывает непосредственно Психолог, а Исполнитель только предоставляет техническую возможность
                    использования функциональных возможностей Сервиса онлайн-консультаций.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.2. На Сервисе онлайн-консультаций Пользователю предоставляется возможность выбора наиболее
                    подходящих для решения вопросов Пользователя Психолога из всей базы специалистов, разместивших
                    информацию о себе на Сервисе онлайн-консультаций. Пользователю предоставляется неограниченный доступ
                    к Личному кабинету, возможность записи на Видеоконсультации согласно графику Психолога, возможность
                    принятия участия в Видеоконсультациях.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.3. Ни Исполнитель, ни Психолог не оказывают медицинские услуги, не занимаются выдачей каких-либо
                    сертификатов или рецептов, а также не осуществляют назначение медицинских препаратов. Исполнитель и
                    Психолог не занимаются лечебной или какой-либо другой медицинской практикой.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.4. Пользователь предоставляет Исполнителю право на использование обратной связи Пользователя для
                    исследований и улучшения качества работы Сервиса онлайн-консультаций, проводимых Видеоконсультаций,
                    анализа целесообразности и качества используемых практических подходов и методов консультирования
                    Психологом. Указанное использование не будет являться нарушением условий конфиденциальности.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.5. Пользователь полностью осознает, что Исполнитель может в любой момент отказать в предоставлении
                    доступа к Сервису онлайн-консультаций, в случае нарушения Пользователем условий настоящего Договора,
                    а также в любых иных случаях, в том числе, и без объяснения причин.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.6. В случае, если Пользователь пропускает Видеоконсультацию согласно установленному с Психологом
                    графику или уведомляет о переносе Видеоконсультации менее, чем за 12 часов до назначенного времени,
                    уплаченные за Видеоконсультацию Психологу денежные средства не подлежат возврату Пользователю и
                    считаются фиксированной абонентской платой.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.7. В случае, если Видеоконсультация не состоялась по вине Психолога и/или Психолог уведомил
                    Пользователя об отмене или переносе Видеоконсультации менее, чем за 12 часов, то, на усмотрение
                    Пользователя, оплаченная за Видеоконсультацию сумма, либо подлежит возврату Пользователю, либо
                    засчитывается в счет оплаты следующей Видеоконсультации.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.8. В случае, если Пользователь опаздывает на назначенную Видеоконсультацию, время
                    Видеоконсультации не продлевается, в случае, если Психолог опаздывает на Видеоконсультацию, время
                    Видеоконсультации продлевается на период опоздания Психолога, либо Видеоконсультация переносится на
                    иную дату, согласованную сторонами.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.9. Для пользования Сервисом онлайн-консультаций Пользователь должен обеспечить наличие следующего
                    оборудования и программного обеспечения:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <span>
                        - Исходящее и входящее интернет-соединение от 3 (трех) Мбит/сек. Скорость интернета можно
                        проверить, перейдя по следующей ссылке: <span style={{color: '#47f'}}
                                                                      onClick={() => window.location.href = 'https://yandex.ru/internet/'}

                    >https://yandex.ru/internet/
                        </span>;

                    </span>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        - Смартфон, ноутбук, стационарный компьютер с качественным видеоизображением и хорошей передачей
                        звука;
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        - Камера внешняя или встроенная;
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        - Объем оперативной памяти RAM устройства от 4 либо 8 Гб (для целей повышения работоспособности
                        и скорости) и более. Объемы оперативной памяти указаны в технических характеристиках устройства,
                        также в разделе «Настройки».
                    </FR>
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.10. Сервис онлайн консультаций предоставляется «как есть» и «при наличии», то есть без любых
                    прямых или косвенных заверений или гарантий, без возможности изменения конфигурации в соответствии с
                    пожеланиями Пользователя. Исполнитель не гарантирует и не делает никаких заявлений относительно
                    безопасности Сервиса онлайн-консультаций. Пользователь отдает себе отчет, что любая передаваемая в
                    ходе консультаций или работы с Сервисом онлайн-консультаций информация может быть перехвачена в
                    процессе передачи, хранения и обработки. Исполнитель не гарантирует, что Сервис онлайн-консультаций
                    не содержит вирусов или других вредоносных элементов, но добросовестно прилагает усилия для создания
                    безопасной среды для пользователя. Использование Сервиса онлайн-консультаций осуществляется
                    Пользователем по своему решению и на свой риск при условии, что Пользователь несет исключительную
                    ответственность за любой ущерб, причинённый компьютерной системе Пользователя, за потерю данных или
                    иной вред, причиненный в результате такой деятельности.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    3.11. У Исполнителя нет доступа к проводимым Видеоконсультациям. Функционал Сервиса
                    онлайн-консультаций не предполагает запись Видеоконсультации или их хранение и обработку. При этом
                    Исполнитель имеет право обрабатывать и обнародовать обезличенные данные Пользователя, такие как пол,
                    возраст, профессия, эмоциональное состояние и иное, в целях анализа, доработки, внесения изменений в
                    Сервис онлайн-консультаций, а также размещения статистических данных в
                    информационно-телекоммуникационной сети «Интернет», на конференциях, предоставления аналитики
                    третьим лицам, в пределах, разрешенных законодательством Российской Федерации, а Пользователь дает
                    на это свое согласие.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    4. ПРАВА И ОБЯЗАННОСТИ ИСПОЛНИТЕЛЯ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    4.1. Исполнитель обязан:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.1.1. Предоставить доступ к Сервису онлайн-консультаций в соответствии с условиями настоящего
                        Договора после прохождения процедуры регистрации на Сервисе онлайн-консультаций.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.1.2. Сохранять анонимность консультирования, кроме случаев, предусмотренных действующим
                        законодательством РФ.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.1.3. Не разглашать ставшие известными в результате исполнения Договора сведения, являющиеся
                        конфиденциальными.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.1.4. Вернуть сумму оплаты за Видеоконсультацию в случае, если Видеоконсультация не состоялась
                        по вине Психолога и/или Психолог уведомил Пользователя об отмене или переносе Видеоконсультации
                        менее, чем за 12 часов, либо, на усмотрение Пользователя, оплаченная за Консультацию сумма может
                        быть засчитана в счет оплаты следующей Видеоконсультации.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.1.5. Предоставлять Пользователю, в случае необходимости, разъяснения по вопросам пользования
                        Сервисом онлайн-консультаций и советов по устранению неполадок в работе.
                    </FR>
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    4.2. Исполнитель вправе:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.2.1. Использовать материалы, полученные в результате оказания услуг, в методических целях, в
                        качестве примеров своей работы, фрагментарно, анонимно.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.2.2. Отказать в доступе к Сервису онлайн-консультаций и расторжении Договора по любым
                        основаниям, в том числе без объяснения причин, в случае невыполнения или ненадлежащего
                        выполнения Пользователем своих обязательств по Договору.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.2.3. Заменить Психолога для Пользователя без объяснения причин.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        4.2.4. Размещать рекламные компании на сайте и организовывать программы скидок и бонусов в
                        работе Сервиса онлайн-консультаций.
                    </FR>
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    5. ПРАВА И ОБЯЗАННОСТИ ЗАКАЗЧИКА
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    5.1. Пользователь обязан:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.1. Оплатить Услуги в соответствии с условиями настоящего Договора.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.2. Сообщить Исполнителю о переносе или отмене Видеоконсультации (оказании услуг) не позднее
                        чем за 12 (двенадцать) часов до назначенного времени оказания услуги. В случае, если
                        Пользователь пропускает Видеоконсультацию согласно установленному с Исполнителем графику или
                        уведомляет о переносе Видеоконсультации менее, чем за 12 часов до назначенного времени,
                        уплаченные за Видеоконсультацию денежные средства не подлежат возврату и считаются фиксированной
                        абонентской платой.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.3. Соблюдать график Видеоконсультаций, согласованный с Исполнителем. В случае, если
                        Пользователь опаздывает на назначенную Видеоконсультацию, время такой Видеоконсультации не
                        продлевается.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.4. Не воспроизводить, не копировать, не распространять, а также не использовать любым иным
                        способом интеллектуальную собственность Исполнителя, в том числе размещенную на Сервисе
                        онлайн-консультаций.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.5. Для пользования Сервисом онлайн-консультаций Пользователь должен самостоятельно
                        обеспечить себя наличием необходимого технического оборудования и доступов к
                        телекоммуникационным сетям (в том числе сети Интернет).
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.6. Пользователь полностью осознает, что Исполнитель ни при каких условиях не может нести и
                        не несет ответственность за результат проведенной Видеоконсультации.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.7. Не передавать логин и пароль к своему Личному кабинету любым третьим лицам, стремиться
                        обеспечить секретность указанных логина и пароля. Немедленно уведомить Исполнителя о случае
                        утери либо хищения логина и /или пароля к своему Личному кабинету.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.8. Воздержаться от предложений Психолога, в случае если такие поступят, провести
                        Видеоконсультацию либо любое иное консультирование напрямую без использования Сервиса
                        онлайн-консультаций.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.10. Сообщать Исполнителю о любых попытках Психолога оказывать консультирование вне пределов
                        Сервиса онлайн консультаций. Не осуществлять агитацию и подстрекательство Психолога оказывать
                        услуги Пользователю без использования Сервиса онлайн-консультаций.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.9. Не размещать любым способом информацию, каким-либо образом дискредитирующую Исполнителя
                        и/или информацию, несоответствующую действительности, порочащую деловую репутацию Исполнителя.
                        Не размещать рекламную информацию, а также любые незаконные, дискредитирующие, несущие угрозу
                        сообщения или сообщения, противоречащие этическим нормам, а также нормам действующего
                        законодательства Российской Федерации.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.3.11. Присутствовать на Видеоконсультации в здравом уме, не курить, не принимать алкоголь во
                        время Видеоконсультации, не покидать её ранее установленного времени, без уважительной причины,
                        а также не проводить Видеоконсультации в состоянии алкогольного и/или наркотического опьянения
                        или под действием лекарственных препаратов, за исключением случаев назначения таких препаратов
                        лечащим врачом Пользователя, о чем Пользователь, в обязательном порядке уведомляет Психолога.
                        Информировать Психолога об изменениях в следующих аспектах своей жизни: работе, образовании,
                        отношениях с родителями, родственниками, близкими друзьями, мужем (женой), партнёрами;
                        информировать Психолога об изменениях в своём физическом и психологическом самочувствии.
                    </FR>
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    &nbsp;
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    5.4. Пользователь вправе:
                </FC>

                <FC
                    ml="1.5rem"
                    mb="1rem"
                    color="#212529">
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.4.1. Требовать от Исполнителя надлежащего оказания услуг по настоящему Договору.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.4.2. Мотивированно требовать от Исполнителя замены Психолога в случае, если по каким-либо
                        причинам Пользователю не подходит выбранный им ранее Психолог из предложенных Исполнителем,
                        указав и обосновав причину отказа от услуг Психолога.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.4.3. Отказаться от исполнения договора возмездного оказания услуг при условии оплаты
                        Исполнителю фактически понесенных им расходов и возмещения убытков. Расторгнуть Договор,
                        направив соответствующее уведомление Исполнителю по электронному адресу: life.help@life-help.ru.
                        После расторжения Договора Исполнитель удаляет все записи на будущие Видеоконсультации из
                        графика Психолога. В случае такого отказа Договор будет считаться прекращенным со дня,
                        следующего за днем получения такого уведомления Исполнителем.
                    </FR>
                    <FR fontSize="0.9rem"
                        mb="0.25rem">
                        5.4.4. Получать, при необходимости, консультации Исполнителя относительно возможностей Сервиса
                        онлайн-консультаций.
                    </FR>
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    6. СТОИМОСТИ УСЛУГ И ПОРЯДОК ОПЛАТЫ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.1. Пользователю предоставлено право использования Сервиса онлайн-консультаций, оплату за
                    пользование он не производит, однако некоторый функционал Сервиса онлайн-консультаций может быть
                    платным.
                </FC>

                <span>
                    6.2. Размер стоимости Видеоконсультации размещены на сайтах:{' '}
                    <span onClick={() => window.location.href = 'https://life-help.ru/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.ru/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.pro/'}
                          style={{color: '#36f'}} className="text-nowrap">
                        https://life-help.pro/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.uk/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.uk/
                    </span>.
                </span>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.2. Оплата всех услуг по настоящему Договору осуществляется в форме предоплаты в размере 100% от
                    стоимости услуг в порядке, установленном настоящим Договором.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.3. Моментом оплаты услуг по настоящему Договору считается поступление средств на расчетный счет
                    Исполнителя.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.4. Пользователю может быть доступна функция безналичной оплаты с банковской карты, в этом случае
                    Исполнитель действует по поручению соответствующего Психолога с привлечением уполномоченного
                    оператора по приёму платежей и является получателем платежа в качестве агента Психолога. Исполнитель
                    не гарантирует отсутствия ошибок и сбоев в работе Сервиса онлайн-консультаций в отношении
                    предоставления возможности безналичной оплаты.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.5. Пользователь самостоятельно оплачивает услуги банков, любые комиссии и сборы (если применимо),
                    связанные с перечислением денежных средств на счет Исполнителя.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.6. Пользователь несет ответственность за корректность предоставленных данных, необходимых для
                    осуществления платежей.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    6.7. Пользователь вправе использовать Промокод для полной или частичной оплаты услуг. Промокод
                    активируется посредством введения Промокода в соответствующее поле при оплате услуги на Сервисе
                    онлайн-консультаций Исполнителя.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    7. ОТВЕТСТВЕННОСТЬ СТОРОН
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.1. В случае неисполнения или ненадлежащего исполнения сторонами своих обязательств по настоящему
                    Договору, стороны несут ответственность в соответствии с действующим законодательством Российской
                    Федерации, а также условиями настоящего Договора.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.2. Исполнитель не несет ответственности за психическое и физическое состояние, а также за
                    психическую и физическую безопасность Пользователя. Пользователь осознает, что Сервис
                    онлайн-консультаций предназначен для относительно здоровых людей, которые не имеют проблем со
                    здоровьем (как физических, так и психологических), угрожающих жизни Пользователя или иных лиц.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.3. В случае предоставления Пользователем недостоверной информации и/или контактных данных,
                    Исполнитель не несет ответственности за ненадлежащее оказание услуг.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.4. Исполнитель не несет ответственности за ложные сведения, предоставленные Пользователем в
                    анкете, заполняемой на Сайте онлайн-консультаций.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.5. Исполнитель и Психолог не несут ответственности за выполнение Пользователем рекомендаций
                    Психолога, выполнение домашних заданий, связанные с разрешением проблемной ситуации и т.п.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.6. Исполнитель не несет ответственности за недостижение Пользователем ожидаемых им результатов,
                    либо несоответствие полученного результата ожиданиям Пользователя.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    7.7. Ответственность Исполнителя по любым искам или претензиям, связанным с выполнением настоящего
                    Договора, не может превышать сумм, фактически уплаченных Исполнителю за оказанные в соответствии с
                    условиями настоящего Договора услуги либо реального ущерба, причиненного Исполнителем, в зависимости
                    от того, какая из этих сумм окажется меньшей.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    8. КОНФИДЕНЦИАЛЬНОСТЬ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    8.1. Предоставляя свои персональные данные при регистрации на Сервисе онлайн консультаций,
                    Пользователь даёт Исполнителю своё согласие на обработку и использование своих персональных данных
                    согласно ФЗ № 152-ФЗ «О персональных данных» от 27.07.2006 г. различными способами в целях,
                    указанных в настоящем Договоре, в том числе выполнения Исполнителем обязательств перед Пользователем
                    в рамках настоящего Договора, продвижения Исполнителем услуг, направления информационных электронных
                    и смс сообщений клиентской поддержки, контроля качества оказываемых услуг. Пользователь вправе
                    отказаться от получения рекламной и другой информации без объяснения причин путем информирования
                    Исполнителя о своем отказе посредством направления соответствующего заявления на электронный адрес
                    Исполнителя: life.help@life-help.ru.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    8.2. Исполнитель использует персональные данные Пользователя для следующих целей: регистрация
                    Пользователя на Сервисе онлайн консультаций, использование Пользователем функциональных возможностей
                    Сервиса онлайн консультаций, предоставление данных Психологу и иные, предусмотренные настоящим
                    Договором цели. Пользователь осознает, что оставленные им при регистрации данные будут доступны
                    Психологам.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    8.3. Исполнитель требует от Психологов соблюдения конфиденциальности и положений Этического кодекса
                    психологов, размещенного по адресу:{' '}
                    <FR onClick={() => window.location.href = 'http://psyrus.ru/rpo/documentation/ethics.php'}
                        color="blue"
                        cls="text-nowrap">
                        http://psyrus.ru/rpo/documentation/ethics.php
                    </FR>
                    , при заключении Договора с ним.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    8.4. Исполнитель не записывает Видеоконсультации, не хранит записи и не обрабатывает их.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    8.5. Исполнитель вправе использовать технологию «cookies». Пользователь настоящим дает согласие на
                    сбор, анализ и использование cookies, в том числе третьими лицами для целей формирования статистики
                    и оптимизации рекламных сообщений. Исполнитель получает информацию об ip-адресе посетителя Сервиса
                    онлайн-консультаций. Данная информация не используется для установления личности посетителя.
                    Исполнитель не несет ответственности за сведения, предоставленные Пользователем на Сервисе
                    онлайн-консультаций в общедоступной форме.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    9. ОБСТОЯТЕЛЬСТВА НЕПРЕОДОЛИМОЙ СИЛЫ (ФОРС-МАЖОР)
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    9.1. Стороны не несут ответственности за полное или частичное неисполнение своих обязательств по
                    Договору, если это неисполнение было вызвано обстоятельствами непреодолимой силы, не зависящими от
                    воли Сторон.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    9.2. К обстоятельствам непреодолимой силы относятся акты органов власти, гражданские волнения,
                    эпидемии, блокада, эмбарго, землетрясения, наводнения, пожары или другие стихийные бедствия иные
                    обстоятельства, которые Стороны не могли ни предвидеть, ни предотвратить своими силами.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    9.3. Сторона, которая не может исполнить свои обязательства по Договору в силу действия
                    обстоятельств непреодолимой силы, должна уведомить в письменном виде другую Сторону о дате
                    наступления указанных обстоятельств и о предполагаемом сроке действия данных обстоятельств, в
                    течение 10 (десяти) рабочих дней с даты наступления обстоятельств непреодолимой силы. К уведомлению
                    должно быть приложено соответствующее свидетельство о действии в соответствующем регионе
                    обстоятельств непреодолимой силы, выданное уполномоченными организациями (Торгово-промышленной
                    палатой).
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    9.4. В случае если обстоятельства непреодолимой силы действуют более 1 (одного) месяца, Стороны
                    вправе расторгнуть Договор.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    10. РЕЗУЛЬТАТЫ ИНТЕЛЛЕКТУАЛЬНОЙ ДЕЯТЕЛЬНОСТИ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    10.1. Исключительные права на Сервис онлайн-консультаций в полном объеме принадлежат Исполнителю.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    10.2. Исполнитель на условиях простой (неисключительной) лицензии предоставляет право использования
                    Сервисом онлайн-консультаций Пользователю для целей исполнения условий по настоящему Договору, что
                    включает в себя право использовать Сервис онлайн-консультаций по прямому функциональному назначению
                    предусмотренными в рамках Сервиса онлайн консультаций способами и с обозначенными в настоящем
                    Договоре запретами и ограничениями Пользователям и, в личных некоммерческих целях.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    10.3. Никаких иных прав, кроме указанных в п.10.2 настоящего Договора Пользователь не приобретает.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    10.4. Любое использование Сервиса онлайн-консультаций кроме случаев, прямо разрешенных настоящим
                    Договором, является запрещенным для Пользователя и считается нарушением условий Договора и ведет к
                    привлечению ответственности в соответствии с действующим законодательством Российской Федерации.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    11. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    11.1. Договор представляет собой полную договоренность между Исполнителем и Пользователем. Настоящим
                    Стороны гарантируют друг другу, что они обладают всеми законными правами и полномочиями для
                    заключения настоящего Договора, соблюдения и выполнения его положений.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    11.2. В случае если одно или несколько положений Договора будут признаны недействительными, то
                    недействительность этих положений не затронет действия иных, действительных положений Договора,
                    которые продолжат свое действие для отношений Сторон, вытекающих из Договора.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    11.3. Если какое-либо из условий Договора Оферты признано недействительным или незаконным, или не
                    может вступить в силу в соответствии с действующим законодательством РФ, такое положение или условия
                    удаляется из Договора Оферты и заменяется новым положением, максимально отвечающим изначальным
                    намерениям Сторон, содержавшимся в настоящем Договоре, при этом остальные положения Оферты
                    (Договора) не изменяются и остаются в силе.
                </FC>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    11.4. Все споры и разногласия Стороны обязуются разрешать путём переговоров. При невозможности
                    разрешения споров и разногласий путем переговоров такие споры будут переданы для рассмотрения в
                    Вахитовский районный суд города Казани в соответствии с законодательством Российской Федерации. До
                    передачи для рассмотрения спора в суд, Стороны обязуются соблюсти претензионный порядок
                    урегулирования разногласий. Срок ответа на полученную от Стороны претензию составляет 30 календарных
                    дней.
                </FC>

                <span>
                    11.5. Исполнитель оставляет за собой право вносить изменения в настоящий Договор в одностороннем
                    порядке. Такие изменения вступают в силу на следующий день после публикации на сайтах Сервиса
                    онлайн-консультаций:{' '}
                    <span onClick={() => window.location.href = 'https://life-help.ru/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.ru/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.pro/'}
                          style={{color: '#36f'}} className="text-nowrap">
                        https://life-help.pro/
                    </span>,{' '}
                    <span onClick={() => window.location.href = 'https://life-help.uk/'}
                          style={{color: '#36f'}}
                          className="text-nowrap">
                        https://life-help.uk/
                    </span>
                    . Настоящим Пользователь соглашается, что он берет на себя ответственность своевременного
                    ознакомления с актуальной редакцией Оферты и получение им услуг после внесения изменений в настоящий
                    Договор автоматически означает его согласие с внесенными изменениями.
                </span>

                <FC fontSize="1rem"
                    mb="1rem"
                    color="#212529">
                    11.7. Действие настоящего Договора подчинено законодательству Российской Федерации.
                </FC>

                <FC fontSize="1.5rem"
                    fontWeight="bold"
                    mb="1rem"
                    color="#212529">
                    12. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ
                </FC>

                <FC fontSize="1rem"
                    className="mb-1"
                    color="#212529">
                    <strong>ООО «Лайф Хелп»</strong>
                </FC>
                <FC fontSize="1rem"
                    className="mb-1"
                    color="#212529">
                    <strong>ИНН:</strong> 1655476459
                </FC>
                <FC fontSize="1rem"
                    className="mb-1"
                    color="#212529">
                    <strong>ОГРН:</strong> 1221600033270
                </FC>
                <FC fontSize="1rem"
                    className="mb-1"
                    color="#212529">
                    <strong>КПП:</strong> 165501001
                </FC>
                <FC fontSize="1rem"
                    className="mb-1"
                    color="#212529">
                    <strong>Электронная почта:</strong> life.help@life-help.ru
                </FC>
            </FC>
        </FC>
    );
};

export default ContractOffer;
